/* ========================== */
/*          REGISTER          */
/* ========================== */
registerForm = {
    init: function () {
        if ($(".register__form form select").length > 0) {
            $(".register__form form select").each(function () {
                $(this).on("change", function () {
                    $(this).addClass("active");
                });
            });
        }
    }
};

$(document).ready(function () {
    registerForm.init();
});


